export function createWhiteboardNode(view, width = null, height = null) {
    const schema = view.state.schema;
    return schema.nodes.whiteboard.create({
        width,
        height,
    });
}
export function handleWhiteboardDropEvent(event, view) {
    // current selection
    const { from, to } = view.state.selection;
    // selected content
    const selectedContent = view.state.doc.slice(from, to);
    const whiteboardNodes = [];
    selectedContent.content.nodesBetween(0, selectedContent.size, (node) => {
        if (node.type.name === "whiteboard") {
            whiteboardNodes.push(node);
        }
    });
    if (whiteboardNodes.length) {
        const pos = view.posAtCoords({ left: event.clientX, top: event.clientY });
        if (!pos) {
            return false;
        }
        const tr = view.state.tr;
        tr.delete(from, to);
        const [whiteboardNode] = whiteboardNodes;
        tr.insert(pos.pos, whiteboardNode);
        view.dispatch(tr);
        event.preventDefault();
        event.stopPropagation();
        return true;
    }
    return false;
}
